var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Rating } from "@gemini/ui";
import { Box } from "@gemini/core";
import { PartnerBadges } from "@/components/contacting/ProviderSection/PartnerBadges";
import { InteractionEnum, } from "@/types";
import { useCustomerAction } from "@/hooks";
export const RatingsAndBadges = ({ testId, rating, badges, }) => {
    const { customerActionLeadInteraction } = useCustomerAction();
    const onClickRating = () => __awaiter(void 0, void 0, void 0, function* () {
        if (rating) {
            yield customerActionLeadInteraction(InteractionEnum.CLICK, "valuation");
            // eslint-disable-next-line no-restricted-globals
            window.open(rating.link, "_blank");
        }
    });
    if (!rating && !badges)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Divider, { marginVertical: "spacing.24", "aria-hidden": "true" }), !!rating && (_jsx(Box, { as: "button", borderStyle: "hidden", padding: "spacing.none", display: "inline-flex", cursor: "pointer", onClick: onClickRating, testId: `${testId}.Rating.link`, children: _jsx(Rating, { size: "24", testId: `${testId}.Rating`, rating: rating.rating, reviews: rating.reviews }) })), badges && _jsx(PartnerBadges, { badges: badges })] }));
};
